// Default source for a dashboard that has no saved code yet: an empty
// default-exported component, ready for the user to fill in. Components
// and React hooks are in scope with no imports (see LiveRender).

import { DASHBOARD_UTC_ISO_TIMESTAMP_MARKER } from '@atbash-labs/ontology-agent-wire'

export const STARTER_CODE = `${DASHBOARD_UTC_ISO_TIMESTAMP_MARKER}
export default function Dashboard() {
  return (
    <div className="p-6">
    </div>
  )
}
`

// Default source for a template that has no saved code yet. Templates
// receive their `default_values` spread as initial props, so the
// starter destructures `{ title }` out of the props (matching the
// `{ "title": "Untitled" }` starter defaults) to make it obvious how
// the prop wiring works.
export const TEMPLATE_STARTER_CODE = `${DASHBOARD_UTC_ISO_TIMESTAMP_MARKER}
export default function Template({ title }: { title: string }) {
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold">{title}</h2>
    </div>
  )
}
`

// Default `default_values` for a brand-new template — paired with
// `TEMPLATE_STARTER_CODE` so the first-paint preview renders
// something. JSON-stringified at create time before being POSTed.
export const TEMPLATE_STARTER_DEFAULTS: Record<string, unknown> = {
  title: 'Untitled template'
}
